<template>
  <div class="message">
    <!-- 搜索 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @customerChange="customerChange"
      @orderChange="orderChange"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar v-if="menuButtonList && menuButtonList.length > 0">
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :reserve="true"
        :data="tableData"
        :columns="columnList"
        :checkbox-config="{ reserve: reserve }"
        row-id="id"
        :loading="load"
        show-footer
        :max-height="$store.state.app.tableHeight"
        :footer-method="footerMethod"
        highlight-current-row
        column-min-width="120"
      >
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import API from '@/api/capitalCenter/moneyDraw';
  import { mapState } from 'vuex';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'interestSumReportHN',
    components: {
      SiruiSearch,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        refreshList: (state) => state.tagsView.refreshList,
      }),
      token() {
        return {
          access_token: this.userInfo.userInfo.access_token,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          tenantCode: this.userInfo.userInfo.tenantCode,
        };
      },
      searchColumns() {
        return [
          {
            name: '客户',
            prop: 'customerCode',
            type: 'searchTableSpec',
            searchType: 'partner',
            isMultiple: true,
            currentValue: this.query.customerName,
            changeMethod: 'customerChange',
            extraData: {
              companyCode: this.$globalVar.subserver.companyCode,
            },
          },
          {
            name: '日期从',
            prop: 'interestDateStart',
            type: 'startDaterangePicker',
          },
          {
            name: '日期到',
            prop: 'interestDateEnd',
            type: 'endDaterangePicker',
          },
          {
            name: '订单',
            prop: 'orderNo',
            type: 'searchTableSpec',
            searchType: 'hnOrder',
            isMultiple: true,
            currentValue: this.query.orderNo,
            changeMethod: 'orderChange',
          },
        ];
      },
      columnList() {
        return [
          {
            field: 'interestDateStart',
            title: '开始日期',
          },
          {
            field: 'interestDateEnd',
            title: '结束日期',
          },
          {
            field: 'customerName',
            title: '客户',
          },
          {
            field: 'orderNo',
            title: '订单',
          },
          {
            field: 'orderInterestAmount',
            title: '利息',
          },
        ];
      },
    },
    data() {
      return {
        query: {
          customerCode: null,
          customerName: null,
          interestDateStart: null,
          interestDateEnd: null,
          orderNo: null,
        },
        load: false,
        tableData: [],
        menuButtonList: [],
        reserve: true,
      };
    },
    mounted() {
      this.getButtonList();
    },
    methods: {
      async getData() {
        if (!this.query.customerName && !this.query.orderNo) {
          return this.$message({
            showClose: true,
            message: '请至少输入客户和订单其中一个查询条件！',
            type: 'error',
          });
        }
        this.load = true;
        const params = { ...this.query };
        let res = await this.$axios.post(API.QUERY_INTERESTSUMREPORTHN_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      customerChange(val) {
        let item = val.val;
        if (item && item.length > 0) {
          this.query.customerCode = item[0].partnerCode;
          this.query.customerName = item[0].partnerZhName;
        } else {
          this.query.customerCode = this.query.customerName = null;
        }
      },
      orderChange(val) {
        let item = val.val;
        if (item && item.length > 0) {
          this.query.orderNo = item[0].contractNo;
        } else {
          this.query.orderNo = null;
        }
      },
      footerMethod({ columns, data }) {
        let returnProps = ['orderInterestAmount'];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (returnProps.includes(column.property)) {
              return XEUtils.toFixedNumber(XEUtils.calSum(data, column.property), 2);
            }
            return null;
          }),
        ];
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 搜索
      searchBtnClick() {
        this.resetBtnClick();
      },
      // 重置
      resetBtnClick() {
        this.getData();
      },
      chooseClick(value) {
        if (value == 'export') {
          this.export();
        }
      },

      // 导出
      export() {
        if (!this.query.customerName && !this.query.orderNo) {
          return this.$message({
            showClose: true,
            message: '请至少输入客户和订单其中一个查询条件！',
            type: 'error',
          });
        }
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        let query = this.filterEmpty(this.query);
        Object.keys(query).forEach((value) => {
          if (XEUtils.isArray(query[value])) {
            query[value + 'Str'] = query[value].join(',');
            delete query[value];
          }
        });
        const params = XEUtils.serialize(query);
        window.location.href = `${baseUrl}${API.EXPORT_INTERSET_SUMMARY}?${params}&access_token=${this.token.access_token}`;
      },
    },
  };
</script>
